// @flow
import update from 'immutability-helper'
import * as React from 'react';
import { Divider, Stack } from '@mui/material';
import { DndProvider, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useCallback, useContext, useEffect, useState } from 'react';
import { FieldRow } from './field-row';
import { TableSettingsContext } from '../with-table-settings';
import _ from 'lodash';


const List = () => {
  const {columns, setColumns} = useContext(TableSettingsContext);

  const [fields, setFields] = useState<typeof columns>([]);

  useEffect(() => {
    setFields(prev => _.isEqual(prev, columns) ? prev : columns)
  }, [columns])

  const findField = useCallback(
    (id: string) => {
      const card = fields.filter((c) => `${c.id}` === id)[0]
      return {
        card,
        index: fields.indexOf(card),
      }
    },
    [fields],
  )

  const moveField = useCallback(
    (id: string, atIndex: number) => {
      const { card, index } = findField(id)
      setFields(
        update(fields, {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        }),
      )
    },
    [findField, fields, setFields],
  )

  const handleDeleteClick = (item: typeof fields[0]) => {
    setFields(prev => {
      const value = prev.filter(i => i !== item);
      setColumns(value);
      return value;
    })
  }

  const [, drop] = useDrop(() => ({
    accept: 'field',
    drop: () => setColumns(fields),
  }), [fields])

  return <Stack ref={drop}>
    {fields.map((item, i, array) => (
      <React.Fragment key={item.id}>
        <FieldRow field={item}
                  moveField={moveField}
                  findField={findField}
                  onDeleteClick={() => handleDeleteClick(item)} />
        {i < array.length - 1 && <Divider />}
      </React.Fragment>
    ))}
  </Stack>
}
export const TableSettingsFields = () => {

  return (
    <DndProvider backend={HTML5Backend}>
      <List />
    </DndProvider>
  );
};

